import { render } from "./OsBasedImageSelection.vue?vue&type=template&id=b6824ffc&scoped=true"
import script from "./OsBasedImageSelection.vue?vue&type=script&lang=js"
export * from "./OsBasedImageSelection.vue?vue&type=script&lang=js"

import "./OsBasedImageSelection.vue?vue&type=style&index=0&id=b6824ffc&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder@2/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6824ffc"]])

export default __exports__